const isNotNullPassword = (data) => {
  const key = 'isNotNullPassword'
  const { value } = data
  const isEmpty = value === '' || value === null ? true : false
  const error = isEmpty ? key : false
  return error ? { error, data } : false
}

export default isNotNullPassword
